import React, { useEffect, useState } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { verifyEmail } from '../api/auth';
import BrandLogo from '../components/BrandLogo';
import '../styles/AuthPage.css';

const VerifyEmailPage = () => {
    const [status, setStatus] = useState('verifying'); // 'verifying' | 'success' | 'error'
    const [message, setMessage] = useState('');
    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        // Supabase sends token_hash and type in the confirmation link query string
        const token = params.get('token_hash') || params.get('token');
        const type = params.get('type') || 'email';

        if (!token) {
            setStatus('error');
            setMessage('Invalid confirmation link. Please request a new one.');
            return;
        }

        verifyEmail(token, type)
            .then((data) => {
                setStatus('success');
                setMessage(data.message || 'Email verified! Redirecting to login...');
                setTimeout(() => history.push('/login'), 2500);
            })
            .catch((err) => {
                setStatus('error');
                setMessage(err.message || 'Verification failed. The link may have expired.');
            });
    }, [history, location.search]);

    return (
        <div className="sc-auth-page">
            <div className="sc-auth-card">
                <header className="auth-header">
                    <BrandLogo className="sc-auth-logo" />
                    <div className="auth-header-text">
                        <h1>Email verification</h1>
                        <p>Checking your confirmation link</p>
                    </div>
                </header>
                <div className="auth-body">
                    <div className="auth-status">
                        {status === 'verifying' && (
                            <div className="sc-loading">
                                <div className="sc-spinner" />
                                <p>Verifying your email...</p>
                            </div>
                        )}
                        {status === 'success' && (
                            <div className="sc-alert sc-alert--success" role="status">{message}</div>
                        )}
                        {status === 'error' && (
                            <>
                                <div className="sc-alert sc-alert--error" role="alert">{message}</div>
                                <Link to="/register" className="sc-btn sc-btn--primary sc-btn--block">
                                    Back to register
                                </Link>
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VerifyEmailPage;
